/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Candidate_Profile_Location_LabelInputs */

const en_candidate_profile_location_label = /** @type {(inputs: Candidate_Profile_Location_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preferred Location`)
};

const de_candidate_profile_location_label = /** @type {(inputs: Candidate_Profile_Location_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bevorzugter Standort`)
};

/**
* | output |
* | --- |
* | "Preferred Location" |
*
* @param {Candidate_Profile_Location_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const candidate_profile_location_label = /** @type {((inputs?: Candidate_Profile_Location_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Candidate_Profile_Location_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_candidate_profile_location_label(inputs)
	return en_candidate_profile_location_label(inputs)
});